<template>
  <a-card :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :span='10'>
            <a-form-item :label="'日期'" :labelCol='{ span: 6 }' :wrapperCol='{ span: 14, offset: 1 }'>
              <a-date-picker v-model='queryParam.date' format='YYYY-MM-DD' />
            </a-form-item>
          </a-col>
          <a-col :span='14'>
            <a-button style='margin-left: 20px' type='primary' @click='getTableData()'>查询</a-button>
            <a-button style='margin-left: 20px' type='primary' @click="getTableData('reset')">重置</a-button>
            <a-upload
              ref='upload'
              name='file'
              :multiple='false'
              :action="'/api/web/webpublic/statistics/insertAdTrafficList'"
              :headers='getHeaders()'
              :data='uploadDataParam'
              :openFileDialogOnClick='openFileDialogOnClick'
              @change='handleChangeUpload'
            >
              <a-button
                type='primary'
                @click='openFileDialogOnClick = true'
                style='margin-left: 10px'
                :loading='uploadLoading'
              >
                上传文件
              </a-button>
            </a-upload>
          </a-col>
        </a-row>
      </a-form>


      <!-- 表格-->
      <a-table :columns="columns" :data-source="tableData" class="components-table-demo-nested">
        <a slot="operation" slot-scope="text">Publish</a>
        <a-table
          slot="expandedRowRender"
          slot-scope="text"
          :columns="childColumns"
          :data-source="tableData"
          :pagination="false"
        >
          <span slot="status" slot-scope="text"> <a-badge status="success" />Finished </span>
          <span slot="operation" slot-scope="text" class="table-operation">
        <a>Pause</a>
        <a>Stop</a>
        <a-dropdown>
          <a-menu slot="overlay">
            <a-menu-item>
              Action 1
            </a-menu-item>
            <a-menu-item>
              Action 2
            </a-menu-item>
          </a-menu>
          <a> More <a-icon type="down" /> </a>
        </a-dropdown>
      </span>
        </a-table>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { queryAdTrafficList, insertAdTrafficList } from '@/webpublicapi/adTrafficList'
import { getHeaders } from '@/utils/request'

import moment from 'moment'

export default {
  name: 'AppList',
  components: {},
  data() {
    return {
      pageConfig: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      uploadLoading: false,
      fileList: [],
      uploadDataParam: {},
      openFileDialogOnClick: false,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        // date: moment()
        //   .add(0, 'days')
        //   .format('YYYY-MM-DD') //默认当天

        date: moment().add('days', 0)
      },
      transformTime(time) {
        return moment(time).format('YYYY-MM-DD')
      },
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },

      tableData: [],
      childTableData: [],
      loading: false,

      columns: [
        {
          title: '国家',
          align: 'left',
          dataIndex: 'country',
          key: 'country'
        },
        {
          title: '应用名称',
          align: 'left',
          dataIndex: 'appName',
          key: 'appName'
        },
        {
          title: '日期',
          align: 'left',
          dataIndex: 'date',
          key: 'date'
        },

        {
          title: '金额花费',
          align: 'left',
          dataIndex: 'spendAmount',
          key: 'spendAmount'
        },
        {
          title: '安装',
          align: 'left',
          dataIndex: 'installs',
          key: 'installs'
        },
        {
          title: '安装成本',
          align: 'left',
          dataIndex: 'installCost',
          key: 'installCost'
        },
        {
          title: '注册户',
          align: 'left',
          dataIndex: 'registeredUsers',
          key: 'registeredUsers'
        },
        {
          title: '申贷户',
          align: 'left',
          dataIndex: 'loanApplicants',
          key: 'loanApplicants'
        },
        {
          title: '申贷成本',
          align: 'left',
          dataIndex: 'loanApplicationCost',
          key: 'loanApplicationCost'
        },
        {
          title: '申贷放款率',
          align: 'left',
          dataIndex: 'loanApprovalRate',
          key: 'loanApprovalRate'
        },
        {
          title: '新户｜均额',
          align: 'left',
          dataIndex: 'newCustomerAverage',
          key: 'newCustomerAverage'
        },
        {
          title: '展示CTR',
          align: 'left',
          dataIndex: 'displayCTR',
          key: 'displayCTR'
        },
        {
          title: '点击率CTR',
          align: 'left',
          dataIndex: 'clickThroughRateCTR',
          key: 'clickThroughRateCTR'
        },
        {
          title: '总数',
          align: 'left',
          dataIndex: 'totalCount',
          key: 'totalCount'
        },
        {
          title: '新户成本',
          align: 'left',
          dataIndex: 'newCustomerCost',
          key: 'newCustomerCost'
        }
      ],
      childColumns: [
        {
          title: '代理商',
          align: 'left',
          dataIndex: 'proxy',
          key: 'proxy'
        },
        {
          title: '渠道',
          align: 'left',
          dataIndex: 'channel',
          key: 'channel'
        },
        {
          title: '投放点位',
          align: 'left',
          dataIndex: 'placement',
          key: 'placement'
        },
        {
          title: '金额花费',
          align: 'left',
          dataIndex: 'spendAmount',
          key: 'spendAmount'
        },
        {
          title: '安装',
          align: 'left',
          dataIndex: 'installs',
          key: 'installs'
        },
        {
          title: '安装成本',
          align: 'left',
          dataIndex: 'installCost',
          key: 'installCost'
        },
        {
          title: '注册户',
          align: 'left',
          dataIndex: 'registeredUsers',
          key: 'registeredUsers'
        },
        {
          title: '申贷户',
          align: 'left',
          dataIndex: 'loanApplicants',
          key: 'loanApplicants'
        },
        {
          title: '申贷成本',
          align: 'left',
          dataIndex: 'loanApplicationCost',
          key: 'loanApplicationCost'
        },
        {
          title: '申贷放款率',
          align: 'left',
          dataIndex: 'loanApprovalRate',
          key: 'loanApprovalRate'
        },
        {
          title: '新户｜均额',
          align: 'left',
          dataIndex: 'newCustomerAverage',
          key: 'newCustomerAverage'
        },
        {
          title: '展示CTR',
          align: 'left',
          dataIndex: 'displayCTR',
          key: 'displayCTR'
        },
        {
          title: '点击率CTR',
          align: 'left',
          dataIndex: 'clickThroughRateCTR',
          key: 'clickThroughRateCTR'
        },
        {
          title: '总数',
          align: 'left',
          dataIndex: 'totalCount',
          key: 'totalCount'
        },
        {
          title: '新户成本',
          align: 'left',
          dataIndex: 'newCustomerCost',
          key: 'newCustomerCost'
        }
      ],
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    getHeaders() {
      return getHeaders()
    },
    getTableData(type = 'normal') {
      if (type == 'reset') {
        this.queryParam.date = moment()
          .add(0, 'days')
          .format('YYYY-MM-DD')
      }
      this.loading = true
      this.queryParam.pageNum = this.pageConfig.pageNum
      this.queryParam.pageSize = this.pageConfig.pageSize
      if(this.queryParam.date){ //格式化日期
        this.queryParam.date=this.transformTime(this.queryParam.date)
      }
      queryAdTrafficList(this.queryParam).then(res => {
        this.pageConfig.total = res.data.total
        let data = res.data.rows

        this.tableData = data
        this.loading = false
      })
    },
    handleSizeChange(size) {
      this.pageConfig.pageSize = size
      this.getTableData()
    },
    handleCurrentChange(page) {
      this.pageConfig.pageNum = page
      this.getTableData()
    },
    handleChangeUpload(info) {
      if (info.file.status === 'done') {
        if (info.file.response.code === 1000) {
          this.$message.success(`${info.file.name} file uploaded successfully`)
          this.getTableData('reset')

          this.$refs.upload.sFileList = []
        } else {
          alert(info.file.response.msg)
        }
      } else if (info.file.status === 'error') {
        this.uploadLoading = false
        alert('system error!')
      }
    }
  }
}
</script>
<style lang='less' scoped>
@import '~@/assets/less/common.less';
</style>
